import { Component, OnInit } from '@angular/core';
import { IJobTitle } from '../job-titles/job-titles.types';
import { IAircraftModel } from '../pay-scales/pay-scales.types';
import { HttpErrorResponse } from '@angular/common/http';
import { PayScalesService } from '../pay-scales/pay-scales.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AddEmployeeService } from './add-employee.service';
import { MatDialog } from '@angular/material/dialog';
import { AddEmployeeDialogComponent } from './dialog/add-employee-dialog.component';
import { emailDomainValidator } from '../../shared/validators/email-domain.validator';

@Component({
	selector: 'app-add-employee',
	templateUrl: './add-employee.component.html',
	styleUrls: ['./add-employee.component.scss']
})
export class AddEmployeeComponent implements OnInit {
	constructor(
		private payScalesService: PayScalesService,
		private fb: FormBuilder,
		private addEmployeeService: AddEmployeeService,
		private dialog: MatDialog
	) {}

	public aircraftModels: IAircraftModel[] = [];
	public jobTitles: IJobTitle[] = [];
	public form: FormGroup;

	ngOnInit(): void {
		this.getJobTitles();
		this.getAircraftModel();
		this.form = this.fb.group({
			firstName: new FormControl(null, [Validators.required]),
			lastName: new FormControl(null, [Validators.required]),
			email: new FormControl(null, [Validators.required, emailDomainValidator()]),
			payrollNumber: new FormControl(null, [Validators.required]),
			workdayNumber: new FormControl(null, [Validators.required]),
			jobTitle: new FormControl(null, [Validators.required]),
			aircraftModel: new FormControl(null, [Validators.required]),
			hireDate: new FormControl(null, [Validators.required]),
			phoneNumber: new FormControl(null),
			phoneStipend: new FormControl(false)
		});
	}

	public addEmployee(): void {
		this.addEmployeeService.addEmployee(this.form.value).subscribe(
			result => {
				this.dialog
					.open(AddEmployeeDialogComponent, {
						height: '140px',
						width: '400px',
						data: { message: 'Employee added successfully!' }
					})
					.afterClosed()
					.subscribe(result => {
						this.form.reset();
						this.form.get('phoneStipend').reset(false);
					});
			},
			(error: HttpErrorResponse) => {
				this.dialog.open(AddEmployeeDialogComponent, {
					height: '140px',
					width: '400px',
					data: { message: 'Error adding employee.' }
				});
			}
		);
	}

	public getAircraftModel(): void {
		this.payScalesService.getAircraftModel().subscribe(
			(DATA: IAircraftModel[]) => {
				if (DATA) {
					this.aircraftModels = DATA;
				}
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}

	public getJobTitles(): void {
		this.payScalesService.getJobTitles().subscribe(
			(DATA: IJobTitle[]) => {
				if (DATA) {
					this.jobTitles = DATA;
				}
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}
}
